(function(root){
  'use strict';
  const packs = {
    1:{quantity:1,days:30,once:5999,subscription:5099,retail:5999,variantId:50488840192299},
    2:{quantity:2,days:60,once:9598,subscription:8158,retail:11998,variantId:50488840225067},
    3:{quantity:3,days:90,once:12598,subscription:10708,retail:17997,variantId:50488840257835}
  };
  function getOffer(quantity,mode){
    const pack=packs[quantity];
    if(!pack||!['subscription','once'].includes(mode))throw new Error('Invalid offer selection');
    const cents=mode==='subscription'?pack.subscription:pack.once;
    return {...pack,mode,cents,interval:pack.days+' days',perDay:cents/pack.days,perTub:cents/pack.quantity,saving:Math.round((1-cents/pack.retail)*1000)/10};
  }
  const api={packs,getOffer};
  if(typeof module!=='undefined'&&module.exports)module.exports=api;
  else root.CRTXOffer=api;
})(typeof window!=='undefined'?window:globalThis);
